import {
  assignPinToDevice,
  getPinFormState,
  getSelectedDeviceData,
  initPinForm,
} from "../redux/voiceControl-slice";
import {
  getErrorMsg,
  isValid,
  validateForm,
} from "../services/validation-service";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { voiceControlDevicePinValidation } from "../shared/validation";

export function useVoiceControlPinForm() {
  const [pin, setPin] = useState("");
  const [pristine, setPristine] = useState(true);
  const dispatch = useDispatch();
  const { assignPinInProgress, pinError, pinDialogStatus } =
    useSelector(getPinFormState);
  const { cloudId } = useSelector(getSelectedDeviceData);

  function handleSubmit() {
    setPristine(false);
    if (isValid(validationErrors)) {
      dispatch(assignPinToDevice({ cloudId, pin }));
    }
  }

  function handleChange(event) {
    setPin(event.target.value);
  }

  function initForm() {
    setPin("");
    setPristine(true);
    dispatch(initPinForm());
  }

  const validationErrors = validateForm(
    { form: { pin } },
    voiceControlDevicePinValidation
  );
  const pinInputErrorMsg = getErrorMsg(validationErrors, "pin");

  return {
    pin,
    pristine,
    assignPinInProgress,
    pinError,
    pinDialogStatus,
    pinInputErrorMsg,
    cloudId,
    handleChange,
    handleSubmit,
    initForm,
  };
}
